import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as FooterIcon } from "../../img/icons/Logo_mappser.svg";


const useStyles = makeStyles(theme => ({
  footer: {
    padding: '44px 0 34px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}));

const Footer = () => {
  const classes = useStyles();
  return <div className={classes.footer}><FooterIcon/></div>;
};


export default Footer;
